
import { window } from 'globalthis/implementation';
import React from 'react';
import Page from 'src/components/Page';
import View from "./view"



function index(props) {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const data = params.get('search');




    return (
        <Page title="Home | Leon Gallery Premier Art Auction House in the Philippines">
            <View param={data} />
        </Page>
    );
}

export default index;